import React, {
  lazy,
  Suspense,
  useCallback,
  useMemo,
  useRef,
  useState,
} from "react";
import { SubHeading } from "../../shared/Components";
import { CommonModal, MarketModal } from "../../shared/Components/Modal";
import { useQueryClient } from "@tanstack/react-query";
import MarketSettings from "../GameSettings/MarketSettings";

const MarketBody = lazy(() => import("./MarketBody"));

const Market = () => {
  const refetchRef = useRef(null);

  const [isShow, setIsShow] = useState({
    isOpen: false,
    rowData: null,
    modalTitle: "",
    modalContent: null,
  });

  const handleModal = (rowData, title = "", modalContent = MarketModal) => {
    setIsShow({
      isOpen: true,
      modalContent,
      modalTitle: title,
      rowData,
    });
  };

  const handleMarketSetting = useCallback((rowData) => {
    setIsShow({
      isOpen: true,
      modalContent: MarketSettings,
      modalTitle: "Market Settings",
      rowData,
    });
  });

  return (
    <>
      <SubHeading
        isAdd={true}
        handleShowHide={() => handleModal({}, "Create")}
        isBack={true}
      />
      <Suspense fallback={<div>Loading...</div>}>
        <MarketBody
          onRefetchReady={(fn) => (refetchRef.current = fn)}
          onMarketSetting={handleMarketSetting}
        />
      </Suspense>
      {isShow?.isOpen && (
        <CommonModal
          size={isShow.modalTitle === "Market Settings" ? "xxl" : "md"}
          isShow={isShow.isOpen}
          handleModalHide={() =>
            setIsShow((prev) => ({
              ...prev,
              isOpen: false,
              rowData: {},
              name: "",
            }))
          }
          modalTitle={isShow.modalTitle}
        >
          {isShow.modalContent &&
            React.createElement(isShow.modalContent, {
              handleModalHide: () =>
                setIsShow((prev) => ({
                  ...prev,
                  isOpen: false,
                  rowData: {},
                  name: "",
                  modalTitle: "",
                  apiFlag: !prev.apiFlag,
                })),
              rowData: isShow.rowData,
              fetchData: () => refetchRef.current?.(),
            })}
        </CommonModal>
      )}
    </>
  );
};

export default Market;
